import React, { memo } from 'react'
import { faHexagonVerticalNftSlanted } from '@fortawesome/pro-duotone-svg-icons'
import { Box, Card, Divider, Stack } from '@mui/material'

import RedeemImage from '../shared/redeem/RedeemImage'
import FaIcon from '../shared/faIcon/FaIcon'
import Button from '../shared/button/Button'
import Text from '../text/Text'

const CommonNftCard = ({
  actionLabel,
  image,
  name,
  onClick,
  skipIcon = false,
  ...restProps
}) => {
  const renderFooter = () => (
    <Box
      sx={{
        px: 2,
        py: 2.5,
        gap: 0.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
      }}
    >
      <Button variant='contained' label={actionLabel} onClick={onClick} />
    </Box>
  )
  return (
    <Card sx={{ width: 1 }}>
      <RedeemImage image={image} name={name} onClick={onClick} {...restProps} />
      <Box
        sx={{
          px: 2,
          py: 2.5,
          minWidth: 0,
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column'
        }}
      >
        <Stack direction='row' spacing={1} alignItems='center' sx={{ mb: 0.5 }}>
          {!skipIcon && <FaIcon icon={faHexagonVerticalNftSlanted} />}
          <Text variant='subtitle2' color='inherit' noWrap label={name} />
        </Stack>
      </Box>
      <Divider sx={{ borderStyle: 'dashed' }} />
      {renderFooter()}
    </Card>
  )
}

export default memo(CommonNftCard)
